import { PaypalIcon } from '@/assets/theme/default/surveyIcons/paymentType/PaypalIcon';
import { BankTransferIcon } from '@/assets/theme/default/walletIcons/paymentType/BankTransferIcon';
import { CheckIcon } from '@/assets/theme/default/walletIcons/paymentType/CheckIcon';
import { GiftCardIcon } from '@/assets/theme/default/walletIcons/paymentType/GiftCardIcon';
import { ManualPaymentIcon } from '@/assets/theme/default/walletIcons/paymentType/ManualPaymentIcon';
import { PrepaidIcon } from '@/assets/theme/default/walletIcons/paymentType/PrepaidIcon';
import { ProformaInvoiceIcon } from '@/assets/theme/default/walletIcons/paymentType/ProformaInvoiceIcon';
import { UploadInvoiceIcon } from '@/assets/theme/default/walletIcons/paymentType/UploadInvoiceIcon';

interface WalletPaymentIconProps {
    id: number;
}

export const WalletPaymentIcon = ({ id }: WalletPaymentIconProps) => {
    // ID accordance
    // 1	Bank transfer
    // 2	Cheque
    // 3	PayPal transfer
    // 4	Amazon.de
    // 5	Amazon.fr
    // 6	GoGift
    // 7	Bol.com
    // 8	Amazon.com Gift Card
    // 9	Amazon.ca Gift Card
    // 10	Manual Payment
    // 11	Prepaid Card
    // 12	Amazon.co.uk Gift Card
    // 13	Prezzee
    // ...
    // 18   Upload invoice
    // 19   Proforma invoice

    switch (id) {
        case 1:
            return <BankTransferIcon />;
        case 2:
            return <CheckIcon />;
        case 3:
            return <PaypalIcon />;

        case 10:
            return <ManualPaymentIcon />;
        case 11:
            return <PrepaidIcon />;

        case 18:
            return <UploadInvoiceIcon />;
        case 19:
            return <ProformaInvoiceIcon />;
        default:
            return <GiftCardIcon />;
    }
};
